import React, { useState } from 'react';  
import locationImg from 'images/location_icon-9x11.png';
import dotBtnImg from 'images/dotbtn.png'; 
import constants from 'utils/constants';
import { ItemWrapper, ItemGradientFilter, ItemTop, TopInfo, InfoLeft, InfoRight, UserName, ProfileImgWrapper, ProfileImg, ItemMid, 
        ActivityWrapper, ActivityTxt, TitleWrapper, DescriptionWrapper,EllipsisDescriptionTxt, DescriptionTxt, MoreBtn, LocationImgWrapper, LocationImg, LocationTxt, CategoryItem, ProfileOptionBtn, OptionImg, 
        MbtiItem,   TagList, ItemBottom, JoinBtn, JoinBtnTxt } from './style';
export default function MatchingRoomListItem({roomInfo, onOptionClick,isOwner , type="normal"}) {
  
  const [showFullTxt, setShowFullTxt] = useState(true);
  let profileImgSrc = `${constants['imagePath']}/user_profile_img/${roomInfo['profile_img']}`;
  let preferredActivityTxt = null;
  let preferredMbtiTxt = null;
  let preferredLocationTxt = null;
  let preferredInterestList = [];
  if(roomInfo)
  {
    if(roomInfo?.activities && roomInfo['activities'][0])
    {
      preferredActivityTxt = roomInfo['activities'][0]['name'];
    }
    if(roomInfo?.interests)
    {
      preferredInterestList = roomInfo['interests'];
    }
    if(roomInfo?.mbtis)
    {
      preferredMbtiTxt = roomInfo['mbtis'][0]['name'];
    }
    if(roomInfo?.locations && roomInfo['locations'][0])
    {
      preferredLocationTxt = roomInfo['locations'][0]['name'];
    }
  }

  const itemWrapperStyle = (type==='recommend')?{backgroundColor : '#FFF4D8'}:{};
  const categoryItemStyle = (type==='recommend')?{background:`#FFE89B`}:{};

  return (
    <ItemWrapper style={itemWrapperStyle}>
      <ItemTop>
        <ProfileImgWrapper>
          <ProfileImg src={profileImgSrc} />
        </ProfileImgWrapper>
        <div>
          <TopInfo>
            <InfoLeft>
              <UserName>{roomInfo['nickname']}</UserName>
              {
                (preferredLocationTxt)
                ?(<>
                  <LocationImgWrapper><LocationImg src={locationImg} /> </LocationImgWrapper>
                  <LocationTxt>{preferredLocationTxt}</LocationTxt>
                  </>)
                :(null)
              }
            </InfoLeft>
            <InfoRight>
              {
                (isOwner)
                ?(
                  <ProfileOptionBtn data-item-no={roomInfo['no']} onClick={(e)=>{if(onOptionClick) onOptionClick(roomInfo['no']);}}>
                    <OptionImg src={dotBtnImg} />
                  </ProfileOptionBtn>
                  )
                :(null)
              }
            </InfoRight>
          </TopInfo>
          <TagList>
          {
            (type!=='recommend')
            ?(<ItemGradientFilter></ItemGradientFilter>)
            :(null)
          } 
          {
            (preferredMbtiTxt)?(<MbtiItem>#{preferredMbtiTxt}</MbtiItem>):(null)
          }
          {
            preferredInterestList.map((value, index)=>{
              return(<CategoryItem style={categoryItemStyle} key={`matching-room-${roomInfo['no']}-category-${value['interest_no']}`}>#{value['name']}</CategoryItem>)
            })
          }
          </TagList>
        </div>
      </ItemTop>
      <ItemMid>
        <ActivityWrapper>함께 하고싶은 자기계발 <ActivityTxt>{preferredActivityTxt}</ActivityTxt></ActivityWrapper>
        <TitleWrapper>같이 {(roomInfo['title'])?roomInfo['title']:null} 하실분~?</TitleWrapper>
        {
          (showFullTxt)
          ?(<DescriptionWrapper>
              <EllipsisDescriptionTxt>{(roomInfo['description'])?roomInfo['description']:null}</EllipsisDescriptionTxt>
              <MoreBtn onClick={()=>{setShowFullTxt(false)}}>더보기</MoreBtn>
            </DescriptionWrapper>)
          :(<DescriptionWrapper><DescriptionTxt>{(roomInfo['description'])?roomInfo['description']:null}</DescriptionTxt></DescriptionWrapper>)
        }
      </ItemMid>
      <ItemBottom>
        <JoinBtn to={`matching/room/${roomInfo['no']}`} >
          <JoinBtnTxt>대화하기</JoinBtnTxt>
          {(roomInfo['current_capacity'])?roomInfo['current_capacity']:null}/{(roomInfo['max_capacity'])?roomInfo['max_capacity']:null}
        </JoinBtn>
      </ItemBottom>
    </ItemWrapper>
  );
}